import React from 'react';
import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';

export const NextButton = ({ onNext, style, iconStyle, disabled }) => (
	<Button
		icon={<RightOutlined style={iconStyle} />}
		onClick={onNext}
		style={style}
		disabled={disabled}
	/>
);
